let scriptsLoaded = {};

export default function loadScript(url) {

  function createScriptTag(url) {
    let scriptTag = document.createElement("script")
    scriptTag.src = url
    return scriptTag
  }

  let cachedPromise = scriptsLoaded[url]
  if (cachedPromise) {
    return cachedPromise
  } else {
    let promise = new Promise((resolve) => {
      let scriptTag = createScriptTag(url)
      scriptTag.addEventListener('load', (event) => {
        if (event.isTrusted !== false) {
          resolve()
        }
      })
      document.body.appendChild(scriptTag)
    })
    scriptsLoaded[url] = promise
    return promise
  }
}
